// extracted by mini-css-extract-plugin
export default {"inputGroup":"Switch_inputGroup__jj2z5","label":"Switch_label__wb4-M","errorMessage":"Switch_errorMessage__CxPu4","switch":"Switch_switch__-fdKq"};